<mat-spinner *ngIf="loading"></mat-spinner>
<div *ngIf="!loading" class="edit-actions">
    <mat-spinner *ngIf="loadingAction" [diameter]="20"></mat-spinner>
    <button *ngIf="!loadingAction" type="button" matTooltip="Cancelar" mat-icon-button class="card-inline" (click)="cancel()">
    <mat-icon>clear</mat-icon>
  </button>

    <mat-spinner *ngIf="loadingMasiveAction" diameter="50"> </mat-spinner>
    <!-- <button
    *ngIf="!loadingMasiveAction"
    class="card-inline margin-top-medium"
    [matMenuTriggerFor]="menuItem"
    type="button"
    mat-icon-button
  >
    <mat-icon>more_vert</mat-icon>
  </button> -->

    <button (click)="finish()" *ngIf="!loadingMasiveAction" class="card-inline margin-top-medium" type="button" mat-icon-button>
    <mat-icon>done</mat-icon>
  </button>

    <mat-spinner [diameter]="50" *ngIf="loadingAction"></mat-spinner>
    <mat-menu #menuItem="matMenu">
        <button (click)="setAcepted()" mat-menu-item>
      <span> <b>Aceptar</b></span>
    </button>
        <button (click)="setRejected()" mat-menu-item>
      <span> <b>Rechazar</b></span>
    </button>
        <button (click)="revertStatus()" mat-menu-item>
      <span> <b>Revertir</b></span>
    </button>
    </mat-menu>
</div>
<mat-tab-group #tabGroup>
    <mat-tab label="Detalle">
        <div class="card-base margin-botton-medium">
            <div class="card-content-wizard">
                <div class="card-container mat-elevation-z1">
                    <div class="card-content">
                        <h4>Muestra:</h4>

                        <br />
                        <mat-checkbox [(ngModel)]="allChecked" [indeterminate]="someChecked" (change)="toggleAllReceived($event.checked)" *ngIf="!loading" style="margin: 10px">{{ tube }}</mat-checkbox>

                        <div style="margin: 5px">
                            <app-received-lab-sample inColumn="true" *ngIf="!loading" #receivedLab [medicalAppointmentProcedureIds]="
                  medicalAppointmentProcedureIds
                "></app-received-lab-sample>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mat-tab>
</mat-tab-group>
